import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Features from "./components/Features";
// import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";
// import Pricing from "./components/Pricing";
import "./App.css";

function App() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar />
      <main>
        <Hero />
        <Features />
        {/* <Testimonials /> */}
        <Footer />
      </main>


    </div>
  );
}

export default App;
